import { _products } from "../constants/api";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getAllProducts = async() =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
        const token = userData?.token;

        if (!token) {
          throw new Error('Token not found');
        }

        const response = await fetch(`${_products}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
          },
        });

        const responseJSON = await response.json();
        // toast.success('Products fetched successfully!');
        return responseJSON;
    } catch(error) {
        console.log('Error occurred in the get all products: ', error);
        toast.error('Failed to fetch products.');
    }
}

export const createProducts = async(products) =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
        const token = userData?.token;

        if (!token) {
          throw new Error('Token not found');
        }

        const response = await fetch(`${_products}/create`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
          },
          body: products,
        });

        const responseJSON = await response.json();
        toast.success('Product created successfully!');
        return responseJSON;
    } catch(error) {
        console.log('Error occurred in the create products: ', error);
        toast.error('Failed to create product.');
    }
}

export const updateProducts = async(products, id) =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
        const token = userData?.token;

        if (!token) {
          throw new Error('Token not found');
        }

        const response = await fetch(`${_products}/${id}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
          },
          body: products,
        });

        const responseJSON = await response.json();
        toast.success('Product updated successfully!');
        return responseJSON;
    } catch(error) {
        console.log('Error occurred in the update products: ', error);
        toast.error('Failed to update product.');
    }
}

export const deleteProducts = async(id) =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
        const token = userData?.token;

        if (!token) {
          throw new Error('Token not found');
        }

        const response = await fetch(`${_products}/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
          },
        });

        const responseJSON = await response.json();
        toast.success('Product deleted successfully!');
        return responseJSON;
    } catch(error) {
        console.log('Error occurred in the delete products: ', error);
        toast.error('Failed to delete product.');
    }
}

export const getParticularProducts = async(id) =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
        const token = userData?.token;

        if (!token) {
          throw new Error('Token not found');
        }

        const response = await fetch(`${_products}/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
          },
        });

        const responseJSON = await response.json();
        // toast.success('Product fetched successfully!');
        return responseJSON;
    } catch(error) {
        console.log('Error occurred in the get particular product: ', error);
        toast.error('Failed to fetch product.');
    }
}
